// extracted by mini-css-extract-plugin
export var dividerContainer = "_6y-0";
export var line = "_6y-1";